import { render, staticRenderFns } from "./SchoolLayoutDataCenter.vue?vue&type=template&id=7c51d5a7&scoped=true&"
import script from "./SchoolLayoutDataCenter.vue?vue&type=script&lang=js&"
export * from "./SchoolLayoutDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLayoutDataCenter.vue?vue&type=style&index=0&id=7c51d5a7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51d5a7",
  null
  
)

export default component.exports